import React from 'react';
import AddCreatedLoadFunctional from './components/add-create-load-functional';
import './styles.scss';

const AddCreatedLoad = ({ state, setState, refreshList }) => {
	return <AddCreatedLoadFunctional {...{ state, setState, refreshList }} />;
};

export default AddCreatedLoad;
